<template>
  <div class="Verify-wrapper">
    <el-container>
      <el-header class="Verify_header">
        <p>访客预约</p>
      </el-header>
      <el-main>
        <!-- 二维码区域 -->
        <div v-if="showQrcode" id="Qrcode">
          <div class="iframe-wrap">
            <iframe
                :src="qrcodeUrl"
                frameborder="0"
                scrolling="no"
                class="qrcode-iframe"
            ></iframe>
          </div>
          <p class="qrcode-tip">若未显示二维码或提示无权限，请确认是否已申请当天的访客预约</p>
        </div>
        <!-- 表单区域 -->
        <div v-else id="Verify">
          <el-form
              ref="VerifyForm"
              :model="VerifyForm"
              label-width="0"
              class="demoVerifyForm"
              :rules="verifyRules"
          >
            <el-form-item prop="tel">
              <el-input
                  placeholder="手机号"
                  v-model="VerifyForm.tel"
                  name="tel"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="code" prop="imgCode">
              <el-input
                  v-model="VerifyForm.imgCode"
                  placeholder="输入验证码"
                  style="width: 65%"
              ></el-input>
              <div class="identifybox" >
                <div @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </div>
            </el-form-item>

            <el-form-item class="code" prop="code" v-if="requestCodeSuccess">
              <el-input
                  v-model="VerifyForm.code"
                  placeholder="验证码"
                  name="code"
              ></el-input>
              <button
                  class="buttenStyle"
                  :disabled="isDisabled || sending"
                  @click.prevent="sendCode('VerifyForm')"
              >
                <span v-if="sending" class="loading-spinner"></span>
                {{ buttonText }}
              </button>
            </el-form-item>

            <el-form-item>
              <button
                  class="buttenStyle"
                  @click.prevent="onVerify('VerifyForm')"
                  style="width: 100%"
              >
                提交
              </button>
<!--              <button
                  class="buttenStyle"
                  @click.prevent="skipVerify"
                  style="width: 100%; margin-top: 10px;"
              >
                跳过验证
              </button>-->
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <div class="Verify_footer">
        Copyright@山东青年政治学院
      </div>
    </el-container>
  </div>
</template>

<script>
import SIdentify from "./canvas.vue"
import $ from 'jquery';
export default {
  components: {
    SIdentify,
  },
  data() {
    let checkTel = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!this.checkMobile(value)) {
        callback(new Error("手机号码不合法"));
      } else {
        callback();
      }
    };
    let validateVerifycode =  (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (value !== this.identifyCode) {
        callback(new Error('验证码不正确!'))
      } else {
        this.requestCodeSuccess=true
        callback()
      }
    };
    let checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机验证码"));
      } else {
        callback();
      }
    };
    return {
      VerifyForm: {
        tel: "",
        code: "",
        imgCode: "",
      },
      keyState: {
        id: "",
        state: 0,
      },
      verifyRules: {
        tel: [{ validator: checkTel, trigger: ["blur"] }],
        code: [{ validator: checkCode, trigger: ["blur", "change"] }],
        imgCode: [{ validator: validateVerifycode, trigger: ["blur", "change"] }],
      },
      buttonText: "发送验证码",
      isDisabled: false,
      sending: false,
      flag: true,
      isFailure: true,
      timer: "",
      isFreqTooHigh: false,
      requestCodeSuccess: false,
      identifyCodes: "abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",
      // ========== 新增：二维码展示 ==========
      showQrcode: false,
      qrcodeUrl: "",
    };
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
            ];
      }
    },

    onVerify(form) {
      this.$refs[form].validate(async (valid) => {
        if (!valid) return;
        if (this.keyState.id != "") {
          const { data: selectres } = await this.$http.post(
              "selectvercode",
              this.keyState
          );
          if (selectres.flag == "success") {
            if (
                selectres.data.vercode == this.VerifyForm.code &&
                selectres.data.state == 0
            ) {
              const { data: res } = await this.$http.post(
                  "login",
                  this.VerifyForm
              );
              if (res.flag == "ok") {
                this.isFailure = false;
                clearInterval(this.timer);

                if (res.token) {
                  sessionStorage.setItem("login_token", res.token);
                }

                sessionStorage.setItem(
                    "user",
                    JSON.stringify(this.VerifyForm.tel)
                );
                sessionStorage.setItem("url", JSON.stringify(res.url));

                setTimeout(() => {
                  this.$message.success("操作成功");
                }, 400);

                const tel = this.VerifyForm.tel;
                this.qrcodeUrl = `https://i.sdyu.edu.cn/messenger/visitor/${tel}`;
                this.showQrcode = true;
              } else {
                this.$message.error("操作失败");
              }
            } else {
              if (selectres.data.state == 0) {
                this.$message.error("验证码错误");
              } else {
                this.$message.error("验证码已过期");
              }
            }
          } else {
            this.$message.error("请重新申请验证码");
          }
        }
      });
    },
/*    skipVerify() {
      const tel = this.VerifyForm.tel;

/!*      // 手机号空的话给个默认值，方便测试
      const finalTel = tel || "17562608276";*!/

      // 直接拼二维码链接，不走后端
      this.qrcodeUrl = `https://i.sdyu.edu.cn/messenger/visitor/${tel}`;
      this.showQrcode = true;

      this.$message.success("已跳过验证");
    },*/
    sendCode(form) {
      this.$refs[form].validateField("tel", async (valid) => {
        console.log("valid", valid);
        if (valid.length > 0) return;
        if (this.sending) return; // 请求进行中，防止重复点击
        // 点击后立即进入 loading 并禁用，直到请求返回
        this.sending = true;
        this.isDisabled = true;
        this.buttonText = "发送中";
        if (this.keyState.id != "") {
          clearInterval(this.timer);
          this.overState(this.keyState.id, -1);
        }
        let time = 60;
        let bigtime = 300;
        try {
          const {data: res} = await this.$http.post(
              "createvercode",
              this.VerifyForm
          );
          this.sending = false;
          if (res.flag == "ok") {
            this.buttonText = time + "s";
            this.isDisabled = true;
            this.keyState.id = res.key;
            if (this.flag) {
              this.flag = false;
              this.timer = setInterval(() => {
                bigtime--;
                time--;
                this.buttonText = time + "s";
                if (time === 0 && this.isFailure) {
                  clearInterval(this.timer);
                  this.buttonText = "重新获取";
                  this.isDisabled = false;
                  this.flag = true;
                }
                if (bigtime === 0 && this.isFailure) {
                  clearInterval(this.timer);
                  this.overState(res.key, -1);
                }
              }, 1000);
            }
          } else if (res.flag == "TimeoutONEmin" || res.flag == "TimeoutTENmin") {
            this.isDisabled = false;
            this.buttonText = "发送验证码";
            this.$message.warning("您的操作过于频繁，请稍后重试！");
            this.refreshCode();
          } else {
            this.isDisabled = false;
            this.buttonText = "发送验证码";
            this.$message.error("发送失败，请重试");
          }
        } catch (e) {
          this.sending = false;
          this.isDisabled = false;
          this.buttonText = "发送验证码";
          this.$message.error("网络异常，请稍后重试");
        }
      });
    },

    checkMobile(str) {
      let re = /^1\d{10}$/;
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },

    async overState(key, state) {
      this.keyState.id = key;
      this.keyState.state = state;
      const {data: res} = await this.$http.post("overstate", this.keyState);
      if (res == "ok") {
        return 1;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    history.pushState(null, null, document.URL);
    if (window.history && window.history.pushState) {
      $(window).on("popstate", function () {
        window.history.pushState("forward", null, "");
        window.history.forward(1);
      });
      window.history.pushState("forward", null, "");
      window.history.forward(1);
    }
  },
};
</script>

<style scoped>
.Verify-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

#Verify {
  max-width: 340px;
  margin: 60px auto;
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  position: relative;
  z-index: 9;
}

/* ========== 新增：二维码区域样式 ========== */
#Qrcode {
  max-width: 340px;
  margin: 60px auto;
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  position: relative;
  z-index: 9;
  text-align: center;
}

.iframe-wrap {
  width: 250px;      /* 加大 */
  height: 250px;     /* 加大 */
  overflow: hidden;
  margin: 0 auto;
}

.qrcode-iframe {
  width: 500px;
  height: 500px;
  zoom: 0.5;         /* 500 × 0.8 = 400，和外层匹配 */
  border: 0;
}


.el-form-item {
  text-align: center;
}

.code >>> .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.code button {
  margin-left: 20px;
  width: 140px;
  text-align: center;
}

.Verify_header {
  background-color: #006934;
  text-align: center;
  color: #ffffff;
  font-size: 120%;
}

.Verify_footer {
  background-color: #006934;
  color: #ffffff;
  text-align: center;
  font-size: 75%;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 20px;
  margin: 0px;
}

.loading-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: verify-spin 0.6s linear infinite;
  vertical-align: -2px;
  margin-right: 6px;
}
@keyframes verify-spin {
  to {
    transform: rotate(360deg);
  }
}

.buttenStyle {
  color: #ffffff;
  background-color: #006934;
  border: 1px solid #006934;
  border-radius: 4px;
  height: 40px;
  width: 100%;
}

.buttenStyle:hover {
  background-color: #247556;
}
</style>
<style>
.el-message-box__wrapper {
  bottom: 30% !important;
}

.sendCodeMessage {
  width: auto !important;
}

.sendCodeMessage .el-message-box__btns .el-button--primary {
  background-color: #006934;
  border-color: #006934;
}

.sendCodeMessage .el-message-box__btns .el-button--primary:hover {
  background-color: #006934;
  border-color: #006934;
}

.identifybox {
  display: flex;
  justify-content: space-between;
  margin-top: 13px;
  margin-left: 5px
}
</style>